import { getFilledArrayOrDefault } from "../../utils";

export function format2Backend(data) {
    const copyData = { ...data };

    const {
        id, user_id, tenant_id, updated, created, type, label, latest_check, latest_location, calibrated_stages, children, parents, parent_meta, images,
        ...meta
    } = copyData;

    // random comment
    const meta_data = Object.keys(meta).map((key) => ({
        key,
        value: meta[key]
    }));

    let parent_meta_data = [];
    if (Array.isArray(parent_meta)) {
        parent_meta_data = parent_meta;
    } else if (parent_meta && typeof parent_meta === "object") {
        parent_meta_data = Object.keys(parent_meta).map((key) => ({
            key,
            value: parent_meta[key]
        }));
    }
    return {
        id,
        user_id,
        tenant_id,
        updated,
        created,
        type,
        label,
        latest_check, // * undefined now
        latest_location,
        calibrated_stages,
        children,
        parents,
        images,
        parent_meta: parent_meta_data,
        meta: meta_data
    };
}

export function format2Frontend(data) {
    const { meta, parent_meta, ...layer } = data ?? {};

    // this was here cause a container can have multiple orders, and each order can have a different variety code
    // but initially we're not manually linking pallets to containers
    // not sure if this will be necessary later
    // const parentVarietyCodes = parent_meta?.filter((m) => m.key === "variety_code")?.map((m) => m.value) || [];

    // if (parentVarietyCodes.length) {
    //     layer.expected_variety_codes = parentVarietyCodes;
    // }

    getFilledArrayOrDefault(meta).forEach((i) => {
        layer[i.key] = i.value;
    });

    const parent_meta_obj = Array.isArray(parent_meta)
        ? getFilledArrayOrDefault(parent_meta).reduce((acc, { key, value }) => ({ ...acc, [key]: value }), {})
        : (parent_meta ?? {});

    // * Extract location_id and stage from latest_location if it exists
    // * For convenience of group_by hook in the frontend
    const location_id = layer.latest_location?.location_id;
    const stage = layer.latest_location?.stage;
    const facility = layer.latest_location?.facility;
    const location = layer.latest_location?.label;
    const parent_ids = getFilledArrayOrDefault(layer.parents).reduce((acc, parent) => ({
        ...acc,
        [`${parent.type}_id`]: parent.id,
        [parent.type]: parent.label
    }), {});
    return { ...layer, parent_meta: parent_meta_obj, location_id, stage, facility, location, ...parent_ids };
}

export const extractMetaProperties = (array) => {
    return array.map((obj) => {
        const { meta, ...rest } = obj;
        const newObj = { ...rest };
        if (meta && meta.length > 0) {
            meta.forEach(({ key, value }) => {
                newObj[key] = value;
            });
        }
        return newObj;
    });
};


